import { render } from "./Riwayat.vue?vue&type=template&id=c541cf60"
import script from "./Riwayat.vue?vue&type=script&lang=js"
export * from "./Riwayat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__